import React from 'react'
import { SELECTION_MODE_SINGLE, PURCHASE_TYPE_ITEM } from '_utils/constant'
import './style.scss'

export default function OrderItemRow({ item, isLast, products }) {
  const productInfo = item.product || products?.find((prod) => prod.id === item.pid)
  const isSplitcase =
    item.isSplitcase !== undefined
      ? item.isSplitcase
      : Boolean(
          productInfo &&
            productInfo.splitCasePurchase &&
            Object.keys(productInfo.splitCasePurchase).length > 0
        )

  const basePrice = Number(
    item.basePrice !== undefined
      ? item.basePrice
      : item.pPriceNoSubItems !== undefined && item.pPriceNoSubItems !== null
      ? item.pPriceNoSubItems
      : item.pPrice || 0
  )

  const isQuantitiesProduct = Boolean(
    item.isSingleTrackInventory ||
      item.hasChooseQuantities ||
      (item.pSubItemSelectionMode === SELECTION_MODE_SINGLE &&
        Boolean(item.pSubItemTrackInventory)) ||
      productInfo?.subItems?.some(
        (g) =>
          g.trackInventory === true &&
          g.selectionMode === SELECTION_MODE_SINGLE
      )
  )

  const totalQty =
    item.pQuantity ||
    (item.pSubItems || []).reduce(
      (sum, s) => sum + Number(s.qty || 1),
      0
    )

  const hasSubItems = Boolean(
    item.pSubItems && item.pSubItems.length > 0
  )

  return (
    <div className={`order-item-row ${isLast ? 'is-last' : ''}`}>
      <div className='d-flex align-items-center justify-content-between'>
        <div style={{ flex: 1 }}>
          <div className={`order-item-main ${hasSubItems ? 'has-sub-items' : ''}`}>
            <div className='item-title-col'>
              <div className='item-title-wrapper'>
                <span className='item-name'>
                  {item.pName}
                </span>
                {isSplitcase && item.pPurchaseType ? (
                  <span className='item-badge'>
                    {item.pPurchaseType === PURCHASE_TYPE_ITEM
                      ? 'individual'
                      : 'Case/Carton'}
                  </span>
                ) : null}
              </div>
            </div>
            <div className='item-qty-col'>
              QTY: {totalQty}
            </div>
            <div className='item-price-col'>
              {!isQuantitiesProduct && (
                <span>${basePrice.toFixed(2)}</span>
              )}
            </div>
          </div>

          {hasSubItems && (
            <div className='order-item-subs'>
              {item.pSubItems.map((_item, idex) => {
                const subPrice = Number(_item.price || 0)
                const subQty = Number(_item.qty || 1)
                const singlePrice = basePrice + subPrice

                return (
                  <div key={idex} className='sub-item-row'>
                    <div className='sub-item-name-col'>
                      <div>- {_item.name}</div>
                      {!isQuantitiesProduct && subQty > 1 && (
                        <div className='sub-qty-hint'>
                          (+ ${subPrice.toFixed(2)} x{subQty})
                        </div>
                      )}
                    </div>
                    <div className='sub-item-spacer-col' />
                    <div className='sub-item-price-col'>
                      {isQuantitiesProduct ? (
                        <span>
                          ${singlePrice.toFixed(2)} x{subQty}
                        </span>
                      ) : (
                        <span>
                          +$
                          {(subPrice * subQty).toFixed(2)}
                        </span>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
